module.exports = __webpack_public_path__ + "static/media/over4.8f04c58c.jpg";